import React from "react";
import {clone} from "lodash";
import defaultImage from './default_menu.jpeg';

const MenuImage = (props) => {
  let newProps = clone(props)
  newProps.src ||= defaultImage
  newProps.width ||= 150
  newProps.alt ||= ''

  return <img {...newProps} alt={newProps.alt}/>
}

export default MenuImage;